import { combineReducers } from 'redux'
import StatsReducer from './stats/StatsReducer'
import NetworkReducer from './network/NetworkReducer'
import loadingTaskReducer from './loadingTask/LoadingTaskReducer'
export default combineReducers({
  StatsReducer,
  NetworkReducer,
  loadingTaskReducer,
})
